/* eslint-disable no-underscore-dangle */
import { AIW_ADDON_DEFAULT } from './payment'
import { isSignedIn } from './userAuth'
import { allAddonsTypes } from './addonTypes'

export const KISSMETRICS_TRACK_EVENTS = {
  workspace: 'viewed workspace',
  kw_visualization: 'viewed kw visualization report',
  kw_lists: 'viewed kw lists parent screen',
  kw_lists_child: 'viewed kw lists child screen',
  content_ideas: 'viewed content ideas report',
  top_pages: 'viewed top pages report',
  top_keywords: 'viewed top keywords report',
  site_audit_pages: 'viewed site audit pages discovered',
  backlinks_report: 'viewed backlinks report',
  backlink_opportunity_report: 'viewed backlink opportunity report',
  pricing_page: 'viewed the pricing page',
  checkout_page: 'viewed the checkout page',
  clicked_siwg: 'clicked SIWG',
  clicked_lifetime_plan: 'clicked "Get a lifetime plan"',
  clicked_start_my_free_trial: 'Clicked Start my free trial',
  clicked_upgrade: 'clicked Upgrade',
  user_upgraded: 'user upgraded',
  cancelled: 'Subscription cancelled',
  acccount_deleted: 'Account Deleted',
  switch_to_lifetime: 'Switch to Lifetime Access',
  clicked_register: 'Clicked Register',
  clicked_signin: 'clicked Sign In',
  signed_in: 'signed in',
  registered: 'registered',
  clicked_heading: 'clicked heading',
  clicked_webinar: 'clicked webinar',
  actions_alerts: 'actions alerts',
  create_project: 'project created',
  payment_status: 'payment status',
  checkout: 'Checkout',
  billing_status: 'Billing Status',
  data_exported: 'data exported',
  keyword_list_created: 'keyword list created',
  keywords_added_to_list: 'keywords added to list',
  keywords_added_to_rank_tracking: 'keywords added to rank tracking',
  past_due_notice: 'Past Due Notice',
  clicked_view_serp: 'clicked to view SERP',
  new_lost_page: 'viewed new and lost drilldown page',
  anchor_text_page: 'viewed anchor text drilldown page',
  project_creation_actions: 'project creation actions',
  keyword_generator: 'Keyword Generator',
  alert_drilldown_page: 'viewed Alert Drilldown Page',
  alert_drilldown_click: 'In-app Alert Drilldown Clicks',
  filter_activated: 'Filter Activated',
  ignore_issue: 'Issue Ignored',
  restore_issue: 'Issue Restored',
  click_gsc: 'clicked add GSC',
  click_ga: 'clicked add GA',
  gsc_connection_successful: 'GSC connection successful',
  gsc_connection_error: 'GSC connection error',
  ga_connection_successful: 'GA connection successful',
  ga_connection_error: 'GA connection error',
  report_query_canceled: 'report query canceled',
  filter_actions: 'filter actions',
  click_kw_opportunity: 'clicked KW opportunity',
  seo_opportunity_clicked: 'SEO opportunity clicked',
  pages_recrawled: 'pages recrawled',
  rank_tracking_actions: 'rank tracking actions',
  serps_click: 'SERPs click',
  content_optimization_steps: 'content optimization steps',
  wsod: 'WSOD',
  report_generated: 'Report Generated',
  refresh_serp: 'Clicked serp refresh',
  page_optimizer_see_adjacent_topics:
    'Page Optimizer - clicked see adjacent topics',
  page_optimizer_expand_topic: 'Page Optimizer - expanded adjacent topic',
  click_guidance_cta: 'Clicked guidance cta',
  addon_clicked: 'Clicked add-on',
  addon_purchased: 'Purchased add-on Checkout',
  addon_removed: 'Clicked remove add-on',
  btn_clicked: 'button clicked',
  competitor_added_to_project: 'Competitors added to project',
  clicked_workspace: 'Clicked Workspace',
  page_optimizer: 'Page Optimizer',
  clicked_optimize_keyword: 'Clicked Optimize Keyword',
  clicked_next: 'Clicked next page',
  switch_app: 'SwitchApp',
  clicked_update_metric_button: 'ClickedUpdateMetricButton',
  aiw_oder_bump: 'AIW Order Bump',
  bf_click: 'Black Friday 2023 Click',
  bf_checkout: 'BF Checkout View',
  bf_upgrade_modal: 'BF Upgrade Modal View',
  bf_purchase: 'BF Purchase Successful',
}

export const PROPERTY_NAMES = {
  action: 'action',
  btn_location: 'button location',
  plan_tier: 'plan tier',
  payment_method: 'payment method',
  billing_plan: 'billing plan',
  language_preference: 'language preference',
  reason: 'reason',
  paid: 'paid',
  page_name: 'page name',
  my_free_trial_btn_location: 'Start My Free Trial button location',
  register_btn_location: 'Register button location',
  signin_location: 'sign in location',
  user_type: 'user type',
  headlinks_link: 'headlinks link',
  login_type: 'login type',
  three_steps_bar: '3-steps bar',
  account_settings_clicks: 'account settings clicks',
  alerts_clicks: 'alerts clicks',
  free_trial_status: 'free trial status',
  checkout_status: 'Checkout Status',
  aiw_addon: 'AIW2 addon',
  checkout_error: 'Checkout Error',
  billing_status: 'silling_status',
  export_location: 'export location',
  list_created_location: 'list created location',
  keywords_added_location: 'keywords added location',
  update_payment: 'Update Payment',
  serp_location: 'SERP location',
  alert_click_location: 'Alert Click Location',
  alert_drilldown_type: 'Alert drilldown type',
  alert_drilldown_trigger_number: 'Drilldown Trigger Number',
  filter_name: 'Filter Name',
  serps_options: 'SERPs options',
  search_type: 'search type',
  step: 'step',
  headings_added_count: 'headings added count',
  document_shared: 'document shared',
  document_saved: 'document saved',
  opened_shared_document: 'opened shared document',
  opened_saved_document: 'opened saved document',
  btn_name: 'button name',
  btn_action: 'button action',
  km_name: 'KM Name',
  competitors_added_count: 'competitors added count',
  page_optimization_step: 'Page Optimization Step',
  step_name: 'step name',
  aiw_addon_status: 'AIW Add On Status',
  aiw_addon_selected: 'AIW Add On selected',
  subscription_plan_selected: 'Subscription Plan selected',
  bf_plan_tier: 'BF_plan_tier',
}

export const PROPERTY_VALUES = {
  exit_intent: 'exit intent',
  register_cta: 'register for free cta',
  regular_signin: 'top right-hand regular sign in',
  login_to_keep_using_prompt: 'login to keep using prompt',
  upgrade_to_keep_using_prompt: 'upgrade to keep using prompt',
  switch_to_ltd_popup: 'switch to ltd popup',
  billing_settings: 'billing settings',
  billing_upgrade_modal: {
    tier1_monthly: 'bs tier1 monthly block off',
    tier2_monthly: 'bs tier2 monthly block off',
    tier3_monthly: 'bs tier3 monthly block off',
    tier1_lifetime: 'bs tier1 ltd block off',
    tier2_lifetime: 'bs tier2 ltd block off',
    tier3_lifetime: 'bs tier3 ltd block off',
  },
  daily_limit: {
    tier1_monthly: 'daily limit tier1 monthly block off',
    tier2_monthly: 'daily limit tier2 monthly block off',
    tier3_monthly: 'daily limit tier3 monthly block off',
    tier1_lifetime: 'daily limit tier1 ltd block off',
    tier2_lifetime: 'daily limit tier2 ltd block off',
    tier3_lifetime: 'daily limit tier3 ltd block off',
  },
  signin_location: {
    top_bar: 'top bar',
    project_creation: 'last step project creation',
    registration_form: 'registration page form field',
    prompt_modal: 'upgrade prompt modal',
  },
  register_btn: {
    popup_top_bar: 'popup top bar',
    registration_form: 'registration page form field',
    project_creation: 'last step project creation',
    kw_list_empty_parent_screen: 'KW lists empty state parent screen',
  },
  keyword_overview: {
    limit_bar: 'ko limit bar',
    volume_chart: 'ko volume chart',
    questions: 'ko questions block off',
    prepositions: 'ko prepositions block off',
    comparisons: 'ko comparisons block off',
    seo_chart: 'ko seo resutls',
    age_range_chart: 'ko age range',
    add_to_list: 'KW Overview add to list button block off',
    add_to_rank_tracking: 'KW Overview add to rank tracking button block off',
  },
  kw_visualization: {
    questions: 'KWVI - Questions Tab',
    prepositions: 'KWVI - Prepositions Tab',
    comparisons: 'KWVI - Comparisons Tab',
    related: 'KWVI - Related Tab',
    suggestions: 'KWVI - Suggestions Tab',
    visualization: 'KWVI - Visualization Tab',
    data: 'KWVI - Data Tab',
    view_data_card_image: 'KWVI - View Data Card Image',
    export_image_visualzation_chart:
      'KWVI - Export Image - Visualization Chart',
    export_image_data_cards: 'KWVI - Export Image - Data Cards',
    export_image_modal_chart: 'KWVI - Export Image - Modal Chart',
    logo_upload: 'KWVI - Logo Upload',
    block_off: 'KW visualization block off',
  },
  keyword_ideas: {
    limit_bar: 'ki limit bar',
    suggestions: 'ki suggestions block off',
    related: 'ki related block off',
    questions: 'ki questions block off',
    prepositions: 'ki prepositions block off',
    comparisons: 'ki comparisons block off',
    serp: 'ki next serp',
    export: 'ki export selected block off',
    export_all: 'ki export all block off',
    clipboard: 'ki clipboard block off',
    serps_export: 'ki export serp',
    filters: 'ki filters block off',
    filter_upgrade_cta: 'ki filter upgrade cta',
    pagination: 'ki pagination block off',
    add_to_list: 'KW ideas add to list button block off',
    add_to_rank_tracking: 'KW ideas add to rank tracking button block off',
    refresh_serp: 'kw ideas refresh serp',
    domainKeywords: 'ki search by website block off',
  },
  keyword_lists: {
    create_list: 'KW lists create list block off',
    export: 'KW lists export selected block off',
    export_all: 'KW export under keywords',
    serps_export: 'KW export under serps',
    keywords_next: 'KW list child next block off',
    add_to_rank_tracking: 'KW lists add to rank tracking button block off',
  },
  content_ideas: {
    limit_bar: 'ci limit bar',
    results: 'ci main block off',
    keywords: 'ci keywords block off',
    backlinks: 'ci links block off',
    export: 'ci export block off',
    copy: 'ci copy block off',
    keywords_next: 'ci keywords next block off',
    keywords_export: 'ci keywords export block off',
    links_next: 'ci links next block off',
    links_export: 'ci links export block off',
    filters: 'ci filters ',
    pagination: 'ci pagination block off',
  },
  traffic_overview: {
    limit_bar: 'to limit bar',
    traffic_chart: 'to traffic chart',
    ranking_chart: 'to seo keyword ranking chart',
  },
  top_pages: {
    limit_bar: 'tp limit bar',
    results: 'tp main block off',
    keywords: 'tp est visits block off',
    backlinks: 'tp backlinks block off',
    export: 'tp export block off',
    export_all: 'tk export all block off',
    copy: 'tp copy block off',
    keywords_next: 'tp est visits next block off',
    keywords_export: 'tp est visits export block off',
    links_next: 'tp backlinks next block off',
    links_export: 'tp backlinks export block off',
    pagination: 'tp pagination block off',
    filters: 'tp filters block off',
    filter_upgrade_cta: 'tp filter upgrade cta',
  },
  similar_websites: {
    limit_bar: 'Competitors limit bar',
    results: 'sw main block off',
    export: 'sw export block off',
    more_domains: 'sw more domains block off',
    common_kw_next: 'sw common kw next block off',
    common_kw_export: 'sw common kw export block off',
    kw_gap_next: 'sw kw gap next block off',
    kw_gap_export: 'sw kw gap export block off',
    traffic_chart: 'sw traffic chart',
  },
  competitor_tracking: {
    common_kw_next: 'ct common kw next block off',
    common_kw_export: 'ct common kw export all block off',
    kw_gap_next: 'ct kw gap next block off',
    kw_gap_export: 'ct kw gap export all block off',
  },
  backlinks: {
    limit_bar: 'bl limit bar',
    results: 'bl main block off',
    next_button: 'bl next button',
    new: 'bl new block off',
    lost: 'bl lost block off',
    new_lost_next_button: 'newlost next button',
    export_button_top: 'bl export to csv button',
    export_button_bottom: 'bl export button',
    filter: 'bl Advanced Filters',
    follow: 'bl follow block off',
    nofollow: 'bl nofollow block off',
    onelink: 'bl onelink block off',
    anchor_text: 'at drilldown block off',
  },
  backlink_opportunity: {
    limit_bar: 'bl opportunity limit bar',
    backlinks_export: 'bl opportunity backlink export',
    refDomains_export: 'bl opportunity referring domains export',
    export_all: 'bl opportunity export all',
    backlinks: 'blo backlinks block off',
    refDomains: 'blo referring domain block off',
  },
  top_keywords: {
    limit_bar: 'tk limit bar',
    results: 'tk main block off',
    flag: 'tk Flags',
    export_all: 'tk export all block off',
    export: 'tk export selected block off',
    export_under_serps: 'tk export serp',
    copy_to_clipboard: 'tk copy to clipboard block off',
    serp_next: 'tk next serp',
    add_to_list: 'KW traffic add to list button block off',
    add_to_rank_tracking: 'KW traffic add to rank tracking button block off',
    refresh_serp: 'tk refresh serp',
  },
  pricing: {
    top_tier1: 'pricing page top tier1',
    top_tier2: 'pricing page top tier2',
    top_tier3: 'pricing page top tier3',
    mid_tier1: 'pricing page mid tier1',
    mid_tier2: 'pricing page mid tier2',
    mid_tier3: 'pricing page mid tier3',
    bottom_tier1: 'pricing page bottom tier1',
    bottom_tier2: 'pricing page bottom tier2',
    bottom_tier3: 'pricing page bottom tier3',
    footer_tier1: 'pricing page footer tier1',
  },
  site_audit: {
    limit_bar: 'sa limit bar',
    all: 'sa all issues block off',
    issues: 'sa error click prompt',
    all_pages_discovered: 'site audit see all pages discovered block off',
    errors_tab: 'sa critical error tab block off',
    warnings_tab: 'sa warnings error tab block off',
    recommendations_tab: 'sa recommendations tab block off',
    critical_error: 'sa critical error block off',
    warnings_error: 'sa warnings error block off',
    errors: 'sa critical errors block off',
    warnings: 'sa warnings block off',
    recommendations: 'sa recommendations block off',
    found_more: 'sa found more',
    recrawl: 'sa recrawl',
    upgrade_cta: 'sa upgrade cta',
    export: 'sa export block off',
    export_pages_discovered: 'sa pages discovered export block off',
    ignore_issue: 'site audit ignore issues button block off',
    recrawl_issue: 'site audit recrawl pages button block off',
    passed: 'sa seo checks passed block off',
  },
  dashboard: {
    step2_monthly: 'rt step2 monthly block off',
    step2_lifetime: 'rt step2 ltd block off',
    step3_monthly: 'rt step3 monthly block off',
    step3_lifetime: 'rt step3 ltd block off',
    step4_monthly: 'rt step4 monthly block off',
    step4_lifetime: 'rt step4 ltd block off',
    step5_header_monthly: 'rt step5 monthly header block off',
    step5_header_lifetime: 'rt step5 ltd header block off',
    step5_footer_monthly: 'rt step5 monthly footer block off',
    step5_footer_lifetime: 'rt step5 ltd footer block off',
    step6_header_monthly: 'rt step6 monthly header block off',
    step6_header_lifetime: 'rt step6 ltd header block off',
    step6_footer_monthly: 'rt step6 monthly footer block off',
    step6_footer_lifetime: 'rt step6 ltd footer block off',
    updates: 'rt updates block off',
    mobile: 'rt mobile block off',
    keyword_monthly: 'rt keyword monthly block off',
    keyword_lifetime: 'rt keyword ltd block off',
    competitor_monthly: 'rt keyword monthly block off',
    competitor_lifetime: 'rt keyword ltd block off',
    new_project: 'rt new project',
    new_project_header: 'exceed project limit create new project button',
    new_project_footer: 'rt new project footer block off',
    save_unlogged_project: 'rt almost done block off',
  },
  nav_bar: {
    new_project: 'nav bar new project',
  },
  payment_method: {
    paypal: 'paypal',
    credit_card: 'credit card',
  },
  user_type: {
    free: 'free',
    trial: 'trial',
    paid: 'paid',
  },
  plan_tier: {
    free: 'free',
    tier0: 'tier 0',
    tier1: 'tier 1',
    tier2: 'tier 2',
    tier3: 'tier 3',
  },
  billing_plan: {
    free: 'free',
    monthly: 'monthly',
    lifetime: 'lifetime',
  },
  reason: {
    reason_cost: 'cost',
    reason_difficulty_of_use: 'difficulty of use',
    reason_missing_functionality: 'missing functionality',
    reason_using_other_product: 'using other product',
    reason_temporary_cancellation: 'temporary cancellation',
    reason_data_issue: 'data issue',
    reason_not_what_i_was_expecting: 'not what I was expecting',
  },
  page_name: {
    dashboard: 'dashboard',
    pt_report: 'position tracking report',
    workspace: 'workspace',
    kw_overview: 'kw overview report',
    kw_visualization: 'Keyword Visualization',
    kw_ideas: 'kw ideas report',
    kw_lists: 'kw lists report',
    kw_lists_child: 'kw lists child report',
    ci_report: 'content ideas report',
    ta_overview: 'traffic analyzer overview report',
    tp_report: 'top pages report',
    tk_report: 'top keywords report',
    sa_report: 'site audit report',
    bl_report: ' backlinks report',
    pricing: 'pricing page',
    checkout: 'checkout page',
    login_page: 'login_page',
    registration_page: 'registration_page',
    competitor_analysis_page: 'competitor analaysis page',
    notification_settings: 'notification settings',
    account_settings: 'account settings',
    alerts_page: 'alerts page',
    competitor_tracking: 'competitor tracking',
    seo_opportunities: 'Seo opportunities page',
    billing_settings: 'billing settings',
    new_lost_drilldown: 'new and lost drilldown',
    anchor_text_drilldown: 'anchor text drilldown',
    ai_writer: 'AI Writer',
    labs: 'Labs',
    ai_writer_daily_limit: 'AI Writer daily limit alert',
    ai_writer_saved_limit: 'AI Writer saved document alert',
    kw_generator: 'KW Generator',
    keyword_overview: 'keyword overview',
    keyword_ideas: 'keyword ideas',
    kw_traffic: 'keywords by traffic',
    similar_websites: 'similar websites',
    content_ideas: 'content ideas',
    traffic_overview: 'traffic overview',
    tp_traffic: 'top pages by traffic',
    backlink_overview: 'backlink overview',
  },
  limit_type: {
    location_limit: 'step project creation prompt location limit',
    keyword_limit: 'step project creation prompt keyword limit',
    daily_rank_tracking:
      'step project creation prompt daily rank tracking frequency',
    mobile_rank_tracking:
      'step project creation prompt on mobile rank tracking',
    biweekly_calls: 'step project creation prompt yes biweekly coaching calls',
    seo_help: 'step project creation prompt yes personalized seo help',
  },
  headlinks_link: {
    consulting: 'consulting',
    plans_pricing: 'plan and pricing',
  },
  login_type: {
    google: 'google',
    email: 'email',
  },
  webinar_cta: {
    clicked_webinar: 'clicked webinar cta on the corner',
  },
  three_steps_bar: {
    sign_up: 'sign up',
    create_project: 'create a project',
    add_keywords: 'add keywords',
  },
  account_settings_clicks: {
    change_email: 'change email',
    reset_password: 'reset password',
  },
  alerts_clicks: {
    see_all_alerts: 'see all alerts',
    clicked_bell_alert: 'clicked bell alert',
  },
  checkout_status: {
    abandoned: 'abandoned',
    success: 'success',
  },
  export_location: {
    keyword_ideas: 'KI Main',
    keyword_ideas_serp: 'KI SERPs',
    content_ideas: 'CI Main',
    content_ideas_backlinks: 'CI Links',
    content_ideas_keywords: 'CI Keywords',
    top_pages: 'TP Main',
    top_pages_backlinks: 'TP Links',
    top_pages_keywords: 'TP Keywords',
    top_keywords: 'KBT main',
    top_keywords_serp: 'KBT SERPs',
    similar_websites: 'SW main',
    similar_websites_common: 'SW common',
    similar_websites_gap: 'SW gap',
    backlinks: 'BL main',
    backlink_opportunity: 'BL Opportunity main',
    site_audit: 'SA main',
    site_audit_error: 'SA error list',
    site_audit_individual_error: 'SA individual error',
    site_audit_pages_discovered: 'site audit pages discovered',
  },
  update_payment: 'Update payment clicked',
  keywordGenerator: {
    actions: ['keywords generator csv exported'],
    steps: [
      'keywords generator start',
      'keywords generator domain added',
      'keywords generator location added',
      'keywords generator competitor added',
      'keywords generator output displayed',
      'keywords generator completed',
    ],
  },
  alert_trigger: {
    site_audit_trigger01: 'Site Audit 01',
    site_audit_trigger02: 'Site Audit 02',
    site_audit_trigger03: 'Site Audit 03',
    site_audit_trigger04: 'Site Audit 04',
    site_audit_trigger05: 'Site Audit 05',
    site_audit_trigger06: 'Site Audit 06',
    rank_tracking_trigger01: 'new keywords on top 10',
    rank_tracking_trigger02: 'keywords dropped from top 10',
    rank_tracking_trigger03: 'rankings improved',
    rank_tracking_trigger04: 'rankings were lost',
  },
  ai_writer_tools: {
    meta_title: 'meta title',
    meta_description: 'meta description',
    headline_generator: 'headline generator',
    paragraph_rewriter: 'paragraph rewriter',
    people_ask_answers: 'people also ask',
    product_description_generator: 'product description',
    listicle_generator: 'listicle generator',
    hashtag_generator: 'hashtag generator',
  },
  ai_writer_document: {
    rewrite_page_block_off: 'ai rewrite page block off',
    add_paragraph_block_off: 'ai add paragraph block off',
    save_document_block_off: 'ai save document block off',
  },
  addon_clicked: {
    [allAddonsTypes.ADDON_USER]: 'add user',
    [allAddonsTypes.ADDON_DAILYSEARCH]: 'add daily search',
    [allAddonsTypes.ADDON_DOMAIN]: 'add project',
    [allAddonsTypes.ADDON_TRACKEDKEYWORDS]: 'add tracked kws',
    [allAddonsTypes.ADDON_COMPETITOR]: 'add competitors',
    [allAddonsTypes.ADDON_AIW_BLOGGER]: 'add aiw blogger',
    [allAddonsTypes.ADDON_AIW_BUSINESS]: 'add aiw business',
    [allAddonsTypes.ADDON_AIW_SHAKESPEARE]: 'add aiw shakespeare',
  },
  addon_removed: {
    [allAddonsTypes.ADDON_USER]: 'removed user add-on',
    [allAddonsTypes.ADDON_DAILYSEARCH]: 'removed daily search add-on',
    [allAddonsTypes.ADDON_DOMAIN]: 'removed project add-on',
    [allAddonsTypes.ADDON_TRACKEDKEYWORDS]: 'removed tracked kws add-on',
    [allAddonsTypes.ADDON_COMPETITOR]: 'removed competitors add-on',
    [allAddonsTypes.ADDON_AIW_BLOGGER]: 'removed aiw blogger add-on',
    [allAddonsTypes.ADDON_AIW_BUSINESS]: 'removed aiw business add-on',
    [allAddonsTypes.ADDON_AIW_SHAKESPEARE]: 'removed aiw shakespeare add-on',
  },
  addon_block_off: {
    [allAddonsTypes.ADDON_DOMAIN]: 'addon_proj_block_off',
    [allAddonsTypes.ADDON_TRACKEDKEYWORDS]: 'addon_tk_block_off',
    [allAddonsTypes.ADDON_DAILYSEARCH]: 'addon_dailylimit_block_off',
    [allAddonsTypes.ADDON_COMPETITOR]: 'addon_tc_block_off',
    [allAddonsTypes.ADDON_USER]: 'addon_user_block_off',
    [allAddonsTypes.ADDON_AIW_BLOGGER]: 'addon_aiw_block_off',
  },
  manage_users: {
    invite_user: 'invite user',
    remove_user: 'remove user',
  },
  labs: {
    ai_writer: 'Labs - AI Writer',
    kw_visualization: 'Labs - KW Visualization',
  },
  btn_actions: {
    rerun_search: 're-run search',
  },
  page_optimizer: {
    start_scrapping: 'Start - Page scraped',
  },
  sd_refresh_modal_prompt: {
    bulk: 'sd refresh bulk button',
    singleKeyword: 'sd refresh single kw button',
  },
  content_optimization_steps: {
    keyword_ideas: 'kw ideas generate content with ai',
  },
  aiw_addons: {
    [AIW_ADDON_DEFAULT]: 'noaddon',
    [allAddonsTypes.ADDON_AIW_BLOGGER]: 'Blogger',
    [allAddonsTypes.ADDON_AIW_BUSINESS]: 'Business',
    [allAddonsTypes.ADDON_AIW_SHAKESPEARE]: 'Shakespeare',
  },
  aiw_addon_status: {
    abandoned: 'abandoned',
    success: 'success',
    failed: 'failed',
  },
}

export const setKissmetricsAliasing = (id) => {
  window._kmq = window._kmq || []
  window._kmq.push(['identify', id])
}

export const kissmetricsRecordingEvent = (
  eventName,
  property,
  skipSignedInValidation = false,
) => {
  if (!isSignedIn() && !skipSignedInValidation) {
    return
  }

  window._kmq = window._kmq || []
  window._kmq.push(['record', eventName, property])
}
